import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useIncludePriceOnProductSuggestions = createExperimentHook(
  'suggest-show-product-prices',
  false,
  {
    showPrices: true,
  }
);

export const useNewResponseFormatForSuggestions = createExperimentHook(
  'new-format-for-suggestions',
  false,
  {
    useNewFormat: true,
  }
);

export const useAlternativeFacetNavigation = createExperimentHook(
  'alternative-facet-navigation',
  false,
  {
    useAlternativeFacetNavigation: true,
  }
);

export const useChangelogPositionExperiment = createExperimentHook(
  'changelog-position',
  true,
  { alternate: false }
);

export const useNewSearchPredictions = createExperimentHook(
  'new-search-predictions',
  false,
  { new: true }
);

export type HighlightOfferType =
  | 'regular'
  | 'promoted'
  | 'promotedlarge'
  | 'promotedonly'
  | boolean;

export const useHighlightOfferAndPromotedExperiment = createExperimentHook<
  HighlightOfferType
>('highlight-offer', false, {
  regular: 'regular',
  promoted: 'promoted',
  promotedlarge: 'promotedlarge',
  promotedonly: 'promotedonly',
});

export const useHighlightOfferExperiment = createExperimentHook<
  HighlightOfferType
>('highlight-offer-only', false, {
  regular: 'regular',
});
